import { render, staticRenderFns } from "./ItemAmount.vue?vue&type=template&id=22fcf4d6&"
import script from "./ItemAmount.vue?vue&type=script&lang=js&"
export * from "./ItemAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports